<mat-toolbar
    layoutRow
    color="primary"
    class="title"
>
    <div class="spacer">{{data.title}}</div>
    <mat-icon>{{data.icon}}</mat-icon>
</mat-toolbar>
<div class="body">
    <ng-content></ng-content>
</div>
<div layoutRow
     class="actions">
    <div class="spacer"></div>
    <button *ngIf="data.hideDismissButton != true" mat-button color="primary" (click)="close()">{{data.dismissButton}}</button>
    <button *ngIf="data.hideConfirmButton != true" mat-raised-button color="accent" (click)="confirm()" >{{data.confirmButton}}</button>
</div>
